// extracted by mini-css-extract-plugin
export default {"links":"styles_links__kXV4a"};